import { useLoaderData } from '@remix-run/react'
import { useMemo, useState } from 'react'
import ShippingSchedule from './ShippingSchedule'
import WhereAmI from './WhereAmI'
import { DeliveryOptions } from '~/design-system/components'
import { Button, Card, Divider, HeaderCard, Tooltip, TooltipTrigger } from '~/design-system/primitives'
import { Info, LocalMall, LocalShipping } from '~/icons'
import type { loader } from '~/routes/checkout.cart'

export default function ReceiveOrder() {
  const { shippingData } = useLoaderData<typeof loader>()
  const { selectedAddresses, logisticsInfo } = shippingData || {}
  let [isOpen, setOpen] = useState(false)

  const hasPickup = useMemo(() => {
    return shippingData?.availableDeliveryChannels?.includes('pickup-in-point')
  }, [shippingData?.availableDeliveryChannels])

  return (
    <Card className="lg:w-1/4" color="primary" data-component="box-receive-order" border>
      <HeaderCard
        description={
          <>
            <span className="flex-1">Receba seu pedido</span>
            <TooltipTrigger isOpen={isOpen} onOpenChange={setOpen}>
              <Button
                className="p-0"
                onPress={() => {
                  setOpen(!isOpen)
                }}
              >
                <Info className="fill-gray-40" />
              </Button>

              <Tooltip placement="left">
                <div className="flex flex-row w-[246px] gap-0 items-center p-1">
                  <Info className="fill-white text-base mr-2 leading-none" />

                  <span>
                    A mudança do CEP pode alterar os valores e a disponibilidade dos produtos do seu carrinho
                  </span>
                </div>
              </Tooltip>
            </TooltipTrigger>
          </>
        }
        icon={<LocalMall className="fill-gray-60 text-xl" />}
      />
      <Card className="p-0">
        <WhereAmI address={selectedAddresses} />

        {hasPickup ? (
          <>
            <ShippingSchedule />
            <div className="flex items-center gap-2 self-stretch">
              <Divider />
              <span className="text-xs font-medium tracking-[0.0094rem]">ou</span>
              <Divider />
            </div>
          </>
        ) : null}
        {!!shippingData && (
          <Card color="primary" size="full" border>
            <HeaderCard
              className="text-sm"
              description="Opções de Entrega"
              icon={<LocalShipping className="fill-gray-100 text-lg" />}
            />
            <DeliveryOptions logisticsInfo={logisticsInfo} />
          </Card>
        )}
      </Card>
    </Card>
  )
}
